<template>
  <footer class="main-footer">
    <div class="medium-hide large-hide xlarge-hide">
      <div class="center" style="height: 150px">
        <router-link style="width: 100%" v-bind:to="'naniungo'">
          <img style="width: 200px" src="../assets/naniungo_dach.png" />
        </router-link>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-xsmall-size-100">
          <h2>naniungo® Deutschland GmbH</h2>
          <ul>
            <li>
              <router-link v-bind:to="'/naniungo'" exact>
                <a>Home </a>
              </router-link>
            </li>
            <li>
              <router-link v-bind:to="'/about'" exact>
                <a>Über uns</a>
              </router-link>
            </li>
            <li>
              <router-link v-bind:to="'/themen'" exact>
                <a>Themenschwerpunkte</a>
              </router-link>
            </li>
            <li>
              <router-link v-bind:to="'/karriere'" exact>
                <a>Karriere</a>
              </router-link>
            </li>
            <li>
              <router-link v-bind:to="'/blog'" exact>
                <a>Blog</a>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="md-layout-item md-xsmall-size-100">
          <h2>Für Unternehmen</h2>
          <ul>
            <li>
              <router-link
                v-bind:to="'/projects'"
                exact
                style="color: white !important"
              >
                <h4>
                  projects <br />
                  <span
                    style="
                      font-size: 14px;
                      font-weight: 300;
                      margin-top: 5px !important;
                    "
                    >Freelancer / Interim-Manager</span
                  >
                </h4>
              </router-link>
            </li>
            <li>
              <router-link v-bind:to="'/excecutives'" exact>
                <h4>
                  excecutives <br />
                  <span
                    style="
                      font-size: 14px;
                      font-weight: 300;
                      margin-top: 5px !important;
                    "
                    >Fach- / Führungskräfte</span
                  >
                </h4>
              </router-link>
            </li>
            <li>
              <router-link v-bind:to="'/representatives'" exact>
                <h4>
                  representatives <br />
                  <span
                    style="
                      font-size: 14px;
                      font-weight: 300;
                      margin-top: 5px !important;
                    "
                    >Meinungsführer / Influencer</span
                  >
                </h4>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="md-layout-item md-xsmall-size-100">
          <h2>Öffnungszeiten</h2>
          <ul>
            <li>Montag-Freitag</li>
            <li>8:00-19:00 Uhr</li>
          </ul>
          <h2>Adresse</h2>
          <ul>
            <li>Kaistr. 5</li>
            <li>40221 Düsseldorf-Medienhafen</li>
          </ul>
          <h2>Kontakt</h2>
          <ul>
            <li>
              <span style="margin-left: -10px; margin-top: -13px">
                <md-icon>phone</md-icon
                ><span style="padding-left: 15px">0211/ 7817 2880</span>
              </span>
            </li>
            <li>
              <span style="margin-left: -10px; margin-top: -13px">
                <md-icon>print</md-icon
                ><span style="padding-left: 15px">0211/ 7817 2889</span>
              </span>
            </li>
            <li>
              <span style="margin-left: -10px; margin-top: -13px">
                <md-icon>email</md-icon
                ><span style="padding-left: 15px">info@naniungo.com</span>
              </span>
            </li>
          </ul>
        </div>
        <div
          class="md-layout-item md-xsmall-size-100 small-hide medium-hide large-hide"
        >
          <ul>
            <li>naniungo® Deutschland GmbH</li>
            <li>
              <router-link style="width: 100%" v-bind:to="'impressum'">
                Impressum
              </router-link>
            </li>
            <li>
              <router-link style="width: 100%" v-bind:to="'datenschutz'">
                Datenschutz
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="md-layout impressum xsmall-hide">
        <a href="/" target="_blank"> naniungo® Deutschland GmbH</a>
        <router-link v-bind:to="'impressum'">
          <a href="/" target="_blank" style="margin-left: 30px"> Impressum </a>
        </router-link>
        <router-link v-bind:to="'impressum'">
          <a href="/" target="_blank" style="margin-left: 20px">
            Datenschutz
          </a>
        </router-link>
      </div>
    </div>
    <div class="xsmall-hide small-hide">
      <div class="md-layout md-gutter" style="margin-top: 50px">
        <div class="md-layout-item md-xsmall-size-100">
          <img style="width: 200px" src="../assets/naniungo_dach.png" />
          <div
            class="md-elevation-1"
            style="width: 230px; height: 220px; margin-bottom: 20px"
          >
            <div style="margin: 30px; padding: 20px">
              <h2>naniungo verbindet Unternehmen mit Experten!</h2>
              <md-menu md-direction="bottom-end">
                <md-button
                  style="margin-left: 1px"
                  class="md-raised"
                  md-menu-trigger
                >
                  <span
                    style="
                      text-transform: uppercase;
                      font-size: 10px;
                      color: $accent;
                    "
                  >
                    Expertenprofile
                  </span>
                  <md-icon class="green">arrow_forward</md-icon>
                </md-button>
                <md-menu-content>
                  <md-menu-item>
                    <router-link
                      style="width: 100%"
                      v-bind:to="'/projects'"
                      exact
                    >
                      projects
                    </router-link>
                  </md-menu-item>
                  <md-menu-item>
                    <router-link
                      style="width: 100%"
                      v-bind:to="'/executives'"
                      exact
                    >
                      executives
                    </router-link>
                  </md-menu-item>
                  <md-menu-item>
                    <router-link
                      style="width: 100%"
                      v-bind:to="'/representatives'"
                      exact
                    >
                      representatives
                    </router-link>
                  </md-menu-item>
                </md-menu-content>
              </md-menu>
            </div>
          </div>
        </div>
        <div class="md-layout-item md-xsmall-size-100">
          <h2>naniungo® Deutschland GmbH</h2>
          <ul>
            <li>
              <router-link v-bind:to="'/naniungo'" exact>
                <a>Home </a>
              </router-link>
            </li>
            <li>
              <router-link v-bind:to="'/about'" exact>
                <a>Über uns</a>
              </router-link>
            </li>
            <li>
              <router-link v-bind:to="'/themen'" exact>
                <a>Themenschwerpunkte</a>
              </router-link>
            </li>
            <li>
              <router-link v-bind:to="'/karriere'" exact>
                <a>Karriere</a>
              </router-link>
            </li>
            <li>
              <router-link v-bind:to="'/blog'" exact>
                <a>Blog</a>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="md-layout-item md-xsmall-size-100">
          <h2>Für Unternehmen <br /></h2>
          <ul>
            <li>
              <router-link
                v-bind:to="'/projects'"
                exact
                style="color: white !important"
              >
                <h4>
                  projects <br />
                  <span
                    style="
                      font-size: 14px;
                      font-weight: 300;
                      margin-top: 5px !important;
                    "
                    >Freelancer / Interim-Manager</span
                  >
                </h4>
              </router-link>
            </li>
            <li>
              <router-link v-bind:to="'/executives'" exact>
                <h4>
                  executives <br />
                  <span
                    style="
                      font-size: 14px;
                      font-weight: 300;
                      margin-top: 5px !important;
                    "
                    >Fach- / Führungskräfte</span
                  >
                </h4>
              </router-link>
            </li>
            <li>
              <router-link v-bind:to="'/representatives'" exact>
                <h4>
                  representatives <br />
                  <span
                    style="
                      font-size: 14px;
                      font-weight: 300;
                      margin-top: 5px !important;
                    "
                    >Meinungsführer / Influencer</span
                  >
                </h4>
              </router-link>
            </li>
          </ul>
        </div>

        <div class="md-layout-item md-xsmall-size-100">
          <h2>Öffnungszeiten</h2>
          <ul>
            <li>Montag-Freitag</li>
            <li>8:00-19:00 Uhr</li>
          </ul>
          <h2>Adresse</h2>
          <ul>
            <li>Kaistr. 5</li>
            <li>40221 Düsseldorf-Medienhafen</li>
          </ul>
          <h2>Kontakt</h2>
          <ul>
            <li>
              <span style="margin-left: -10px; margin-top: -13px">
                <md-icon>phone</md-icon
                ><span style="padding-left: 15px">0211 7817 2880</span>
              </span>
            </li>
            <li>
              <span style="margin-left: -10px; margin-top: -13px">
                <md-icon>print</md-icon
                ><span style="padding-left: 15px">0211/ 7817 2889</span>
              </span>
            </li>
            <li>
              <span style="margin-left: -10px; margin-top: -13px">
                <md-icon>email</md-icon
                ><span style="padding-left: 15px">info@naniungo.com</span>
              </span>
            </li>
          </ul>
        </div>
        <!-- <div class="md-layout-item md-xsmall-size-100">
        <h2> <br></h2>
        <ul>
          <li>
             <span style="font-size:0.8rem;"
               href="https://www.instagram.com/naniungo_deutschland_gmbh"
               target="_blank">
              <md-icon style="margin-bottom:9px;"
                       :md-src="getSvg('instagram')" />
            </span>
    
             <span style="font-size:0.8rem;"
               href="https://www.instagram.com/naniungo_deutschland_gmbh"
               target="_blank">
              <md-icon style="margin-bottom:9px;"
                       :md-src="getSvg('instagram')" />
            </span>
   
            <span style="font-size:0.8rem;"
               href="https://www.instagram.com/naniungo_deutschland_gmbh"
               target="_blank">
              <md-icon style="margin-bottom:9px;"
                       :md-src="getSvg('instagram')" />
            </span>
            </li>
        </ul>
      </div> -->
      </div>
      <div class="md-layout impressum">
        <a href="/" target="_blank">
          <strong>© Copyright 2024 </strong>
          naniungo® Deutschland GmbH
          <span style="font-size: 10px"> Alle Rechte vorbehalten. </span>
        </a>
        <router-link v-bind:to="'/impressum'" exact>
          <a style="margin-left: 30px"> Impressum </a>
        </router-link>
        <router-link v-bind:to="'datenschutz'">
          <a style="margin-left: 20px"> Datenschutz </a>
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
  methods: {
    getSvg(name) {
      return require("../assets/media/" + name + ".svg");
    },
  },
};
</script>

<style lang="scss" scoped>
.main-footer {
  min-height: 300px;
  padding: 0 16px;
  position: relative;
  z-index: 40;
  background-color: #f0f0f0;
  max-width: 100vw;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
  ul {
    list-style: none;
    padding-inline-start: 0px;
    line-height: 180%;
  }
}

.md-layout-item {
  padding: 0px;
  padding-bottom: 30px;
  justify-content: space-between;
  transition-property: max-width;
  h2 {
    font-size: 1.2rem !important;
    line-height: 130% !important;
  }
}

.impressum {
  position: absolute;
  bottom: 5px;
  left: 50px;
}

.red {
  display: inline-block;
  color: md-get-palette-color(red, 500);
}

.md-theme-default a:not(.md-button) {
  color: rgb(65, 65, 65);
}

@media (min-height: 959px) {
  ul {
    list-style: none;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 0px;
  }
  .md-layout-item {
    padding: 30px;
    padding-bottom: 50px;
    justify-content: space-between;
    transition-property: max-width;
    h2 {
      font-size: 1.2rem !important;
      line-height: 130% !important;
    }
  }
}
h4 {
  line-height: 100% !important;
  color: black;
}

.md-icon {
  color: black;
  font-size: 1rem;
}
.md-icon {
  color: black;
  font-size: 1rem;
}

@media (min-width: 48rem) {
  .Cookie {
    padding-left: 300px;
  }
}
</style>
